import React from 'react'
//import { useState } from 'react';
import {motion} from "framer-motion";


function About (props) {
  const transition = { duration: 2, type: "spring" };
  return (

    <div id="about">
      
<div className='about-img'>
<img src={props.image} alt="about"/>
</div>

<div className='about-text'>
  {props.title}
</div>
<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
Eos praesentium sed dolore aliquid expedita quis repudiandae. Porro at ex sequi,
 sed dolore, quibusdam beatae enim consequatur vitae, 
 esse distinctio placeat!</p>
<button>{props.button}</button>

</div>
  )
}

export default About;